import { initialDataResolver } from 'app/app.resolvers';
import {
  AuthGuard,
  NoAuthGuard,
  PermissionGuard,
} from 'app/modules/auth/guards';

import { Route } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'forgot-password',
        loadChildren: () =>
          import(
            'app/modules/auth/pages/forgot-password/forgot-password.routes'
          ),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('app/modules/auth/pages/reset-password/reset-password.routes'),
      },
      {
        path: 'sign-in',
        loadChildren: () =>
          import('app/modules/auth/pages/sign-in/sign-in.routes'),
      },
      {
        path: 'mfa',
        loadChildren: () =>
          import('app/modules/auth/pages/mfa/mfa.routes'),
      },
      {
        path: 'sign-up',
        loadChildren: () =>
          import('app/modules/auth/pages/sign-up/sign-up.routes'),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () =>
          import('app/modules/auth/pages/sign-out/sign-out.routes'),
      },
      {
        path: 'unlock-session',
        loadChildren: () =>
          import('app/modules/auth/pages/unlock-session/unlock-session.routes'),
      },
      // {
      //   path: 'fleets',
      //   loadChildren: () => import('app/modules/fleets/fleets.routes'),
      // },
    ],
  },

  // Landing routes
  //   {
  //     path: "",
  //     component: LayoutComponent,
  //     data: {
  //       layout: "empty",
  //     },
  //     children: [
  //       {
  //         path: "home",
  //         loadChildren: () => import("app/modules/landing/home/home.routes"),
  //       },
  //     ],
  //   },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, PermissionGuard],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver,
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('app/modules/dashboard/fleets-dashboard.routes'),
      },
      {
        path: 'fleets',
        loadChildren: () => import('app/modules/fleets/fleets.routes'),
      },
      {
        path: 'readiness',
        loadChildren: () =>
          import('app/modules/fleets/readiness/readiness.routes'),
      },
      {
        path: 'registers',
        loadChildren: () => import('app/modules/registers/registers.routes'),
      },
      {
        path: 'reports',
        loadChildren: () => import('app/modules/reports/reports.routes'),
      },
    ],
  },
];
